import { defineStore } from "pinia";
import { reactive, computed, watch } from "vue";
import jwt_decode from "jwt-decode";
import moment from "moment";
export const useStore = defineStore("main", () => {
  let state = reactive({
    token: null,
  });

  let Store = sessionStorage.getItem("main");
  if (Store) Object.assign(state, JSON.parse(Store));

  watch(
    () => state,
    (newState) => {
      sessionStorage.setItem("main", JSON.stringify(newState));
    },
    { deep: true }
  );

  const isLogin = () => !!state.token == true && !isExpired();

  const tokenObject = computed(() =>
    !!state.token == true ? jwt_decode(state.token) : null
  );

  const exp = computed(() =>
    !!tokenObject.value == true
      ? moment.unix(tokenObject.value.exp).format("YYYY-MM-DD HH:mm:ss")
      : null
  );

  const isExpired = () => {
    return !!tokenObject.value == true ? moment().isAfter(exp.value) : false;
  };

  const tokenHeaders = computed(() => {
    return !!state.token == true
      ? {
          headers: {
            Authorization: `bearer ${state.token}`,
          },
        }
      : {
          headers: {},
        };
  });

  const user = computed(() => {
    if (!!tokenObject.value == true) {
      return {
        userid:
          tokenObject.value[
            "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"
          ],
        username: tokenObject.value.userName,
        roles:
          tokenObject.value[
            "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
          ],
      };
    } else {
      return null;
    }
  });

  const isAdmin = computed(() =>
    user.value != null ? user.value.roles.includes("ADMIN") : false
  );

  const isTyper = computed(() =>
    user.value != null ? user.value.roles.includes("TYPER") : false
  );

  const roleIcon = computed(() =>
    user.value != null
      ? user.value.roles.includes("ADMIN")
        ? "star"
        : user.value.roles.includes("TYPER")
        ? "filter_vintage"
        : user.value.roles.includes("SECR")
        ? "pause"
        : "person"
      : ""
  );

  const login = (key) => {
    state.token = key;
  };

  const logout = () => {
    state.token = null;
  };

  return {
    isExpired,
    user,
    exp,
    isLogin,
    login,
    logout,
    tokenHeaders,
    isAdmin,
    isTyper,
    roleIcon,
  };
});
